export enum BoostsSourceEnum {
  Group = 'Group',
  LinkedChannel = 'LinkedChannel',
  Custom = 'Custom'
}
